import { Grid, TextField } from "@mui/material";
import type { Control, UseFormRegister, UseFormWatch } from "react-hook-form";
import SelectAccountListByMethod from "src/common/SelectAccountListByMethod";
import VisitorSelectFieldList from "src/common/VisitorSelectFieldList";
import InvoiceVisitorSelectFieldList from "../visitorInvoice/InvoiceVisitorSelectFieldList";
import type { ISingleInvoiceVisitor } from "../type/visitorType";

type IProps = {
	register: UseFormRegister<any>;
	watch: UseFormWatch<any>;
	control?: Control<any, any>;
	invoiceDetails?: ISingleInvoiceVisitor;
};
const VisitorMoneyReceiptForm = ({
	watch,
	control,
	register,
	invoiceDetails,
}: IProps) => {
	return (
		<Grid container spacing={2}>
			{invoiceDetails?.visitor_first_name ? (
				<Grid item xs={12} sm={6}>
					<TextField
						fullWidth
						disabled
						value={
							invoiceDetails?.visitor_first_name +
							invoiceDetails?.visitor_last_name
						}
					/>
				</Grid>
			) : (
				<Grid item xs={12} sm={6}>
					<VisitorSelectFieldList
						mt='0'
						fieldName='visitor_id'
						register={register}
						isRequired
						hideCustomLabel
					/>
				</Grid>
			)}

			{invoiceDetails?.invoice_no ? (
				<Grid item xs={12} sm={6}>
					<TextField
						fullWidth
						disabled
						value={invoiceDetails?.invoice_no}
					/>
				</Grid>
			) : (
				<Grid item xs={12} sm={6}>
					<InvoiceVisitorSelectFieldList
						mt='0'
						fieldName='invoice_id'
						register={register}
						isRequired
						hideCustomLabel
						watch={watch}
					/>
				</Grid>
			)}

			<SelectAccountListByMethod
				register={register}
				md={12}
				lg={6}
				watch={watch}
				control={control}
			/>
			<Grid item xs={12} sm={6}>
				<TextField
					fullWidth
					label='Payment Date'
					type='date'
					InputLabelProps={{ shrink: true }}
					{...register("payment_date", {
						required: {
							value: true,
							message: "Please, Provide an account name!",
						},
					})}
				/>
			</Grid>
			<Grid item xs={12} sm={6}>
				<TextField
					fullWidth
					label='Amount'
					type='number'
					defaultValue={invoiceDetails?.due}
					{...register("amount")}
				/>
			</Grid>

			{/* <Grid item xs={12} sm={6}>
					<TextField
						fullWidth
						label='Bank Name'
						{...register("bank_name")}
					/>
				</Grid>

				<Grid item xs={12} sm={6}>
					<TextField
						fullWidth
						label='Cheque No'
						{...register("cheque_no")}
					/>
				</Grid> */}

			<Grid item xs={12}>
				<TextField
					fullWidth
					label='Note'
					multiline
					rows={4}
					placeholder='Write additional details (optional)...'
					{...register("note")}
				/>
			</Grid>
		</Grid>
	);
};

export default VisitorMoneyReceiptForm;
